import React from 'react';
import { Check } from 'lucide-react';

interface Props {
  steps: string[];
  currentStep: number;
}

export default function BookingProgressBar({ steps, currentStep }: Props) {
  return (
    <div className="bg-card/50 border-b border-border px-6 py-4">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center gap-0">
          {steps.map((step, index) => (
            <React.Fragment key={`step-${step}`}>
              <div className="flex items-center gap-2 flex-shrink-0">
                <div
                  className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-300 ${
                    index < currentStep
                      ? 'gold-gradient text-primary-foreground'
                      : index === currentStep
                      ? 'bg-primary/20 border-2 border-primary text-primary' :'bg-muted border border-border text-muted-foreground'
                  }`}
                >
                  {index < currentStep ? <Check size={13} /> : index + 1}
                </div>
                <span
                  className={`text-sm font-medium hidden sm:block transition-colors duration-200 ${
                    index === currentStep ? 'text-foreground' : index < currentStep ? 'text-primary' : 'text-muted-foreground'
                  }`}
                >
                  {step}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div className="flex-1 mx-3 h-px bg-border overflow-hidden min-w-4">
                  <div
                    className="h-full gold-gradient transition-all duration-500"
                    style={{ width: index < currentStep ? '100%' : '0%' }}
                  />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}